import { useAppDispatch, useAppSelector } from 'store/hooks';
import React from 'react';
import { updateSelectedModule } from 'store/content/contentSlice';
import { Column } from 'ui/Flex';
import { MobileLayout } from 'ui/MobileLayout';
import { MobileContentRenderer } from '../MobileContentRenderer';

interface LayoutPreviewProps {
    className?: string;
    isSelectable?: boolean;
}

export const LayoutPreview: React.FC<LayoutPreviewProps> = ({ className, isSelectable }) => {
    const currentLayout = useAppSelector(state => state.content.currentLayout);
    const currentModules = useAppSelector(state => state.content.currentModules);
    const selectedModuleId = useAppSelector(state => state.content.selectedModuleId);
    const dispatch = useAppDispatch();

    const updateSelectedModuleId = React.useCallback(
        (id: string) => dispatch(updateSelectedModule(id)),
        [dispatch]
    );

    return (
        <Column align="center" className={className}>
            <MobileLayout>
                <MobileContentRenderer
                    modules={currentModules}
                    anchor={currentLayout && currentLayout.anchor}
                    isSelectable={isSelectable}
                    selectedModuleId={selectedModuleId}
                    updateSelectedModuleId={updateSelectedModuleId}
                />
            </MobileLayout>
        </Column>
    );
};
